module.exports = __webpack_public_path__ + "img/1.4bfe9b2a.svg";